// extracted by mini-css-extract-plugin
export default {"container":"ImoeD","strikeThrough":"aRoM+"};